/* Unified "Content Suite" switcher shown across all four social-content tools:
   Content Intelligence · Flyer Studio · Video Studio · Post Studio.
   Video/Post switch in-place on the Social Studio page (onSelectMode); Flyer &
   Content Intelligence navigate to their routes. Works in both the admin shell
   and the member portal (embedded) so members reach every tool from one row. */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, BookOpen, LayoutTemplate, Brain, GraduationCap } from 'lucide-react';

const TOOLS = [
  { id: 'intelligence', label: 'Content Intelligence', sub: 'research brain', icon: Brain, activeBg: 'bg-[#0F766E] text-white' },
  { id: 'video', label: 'Video Studio', sub: 'short-form video', icon: Sparkles, activeBg: 'bg-[#0A0F1C] text-white' },
  { id: 'post', label: 'Post Studio', sub: 'text + image posts', icon: BookOpen, activeBg: 'bg-fuchsia-600 text-white' },
  { id: 'flyer', label: 'Flyer Studio', sub: 'branded flyers', icon: LayoutTemplate, activeBg: 'bg-[#1E5BA8] text-white' },
  { id: 'resources', label: 'Resources', sub: 'guides & templates', icon: GraduationCap, activeBg: 'bg-[#7C3AED] text-white' },
];

export default function StudioSuiteNav({ active, embedded = false, onSelectMode }) {
  const navigate = useNavigate();
  const routes = {
    social: embedded ? '/portal/studio' : '/admin/social-studio',
    flyer: embedded ? '/portal/studio/flyer' : '/admin/flyer-studio',
    intelligence: embedded ? '/portal/studio/intelligence' : '/admin/intelligence',
    resources: embedded ? '/portal/studio/resources' : '/admin/studio-resources',
  };
  const go = (id) => {
    if (id === active) return;
    if (id === 'video' || id === 'post') {
      if (onSelectMode) onSelectMode(id);
      else navigate(`${routes.social}?mode=${id}`);
    } else if (id === 'flyer') navigate(routes.flyer);
    else if (id === 'resources') navigate(routes.resources);
    else navigate(routes.intelligence);
  };
  return (
    <div className="flex flex-wrap items-center gap-2 mb-5" data-testid="studio-suite-nav">
      {TOOLS.map((t) => {
        const isActive = active === t.id;
        return (
          <button key={t.id} type="button" onClick={() => go(t.id)} data-testid={`suite-nav-${t.id}`}
            className={`inline-flex items-center gap-2 px-4 sm:px-5 py-2.5 rounded-full text-sm font-bold transition ${isActive ? `${t.activeBg} shadow-lg` : 'bg-white border border-[#E2E8F0] text-[#475569] hover:text-[#0A0F1C] hover:border-[#CBD5E1]'}`}>
            <t.icon size={16} aria-hidden="true" />
            {t.label}
            <span className={`hidden md:inline text-[10px] ${isActive ? 'text-white/60' : 'text-[#94A3B8]'}`}>{t.sub}</span>
          </button>
        );
      })}
    </div>
  );
}
